import { render, staticRenderFns } from "./LensCreationModal.vue?vue&type=template&id=8e5c7aca&scoped=true"
import script from "./LensCreationModal.vue?vue&type=script&lang=js"
export * from "./LensCreationModal.vue?vue&type=script&lang=js"
import style0 from "./LensCreationModal.vue?vue&type=style&index=0&id=8e5c7aca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5c7aca",
  null
  
)

export default component.exports